var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessingOncolorDisbled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05031 5V8L12.0755 4L8.05031 0V3C3.60252 3 0 6.58 0 11C0 12.57 0.462893 14.03 1.2478 15.26L2.71698 13.8C2.25135 12.9395 2.00923 11.977 2.01258 11C2.01258 7.69 4.7195 5 8.05031 5ZM14.8528 6.74L13.3836 8.2C13.8264 9.04 14.0881 9.99 14.0881 11C14.0881 14.31 11.3811 17 8.05031 17V14L4.02516 18L8.05031 22V19C12.4981 19 16.1006 15.42 16.1006 11C16.1006 9.43 15.6377 7.97 14.8528 6.74Z",
    fill: "#9CA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingOncolorDisbled);
export default __webpack_public_path__ + "static/media/processing_oncolor_disbled.828c38af0772f8d185c13a1efe2b20ba.svg";
export { ForwardRef as ReactComponent };